import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Crown, ChevronRight } from 'lucide-react';

// Home: "Oggi Vincenzo ha scelto X partite per l'Area VIP" (no match details)
export const VipTodayBanner = () => {
  const [matches, setMatches] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/vip-predictions/today-summary`, { timeout: 10000 })
      .then((r) => setMatches(r.data?.matches || 0))
      .catch(() => {});
  }, []);

  if (!matches) return null;
  return (
    <div className="px-4 pt-4">
      <button
        onClick={() => navigate('/vip')}
        className="w-full flex items-center gap-3 rounded-2xl px-4 py-3 bg-gradient-to-r from-[#2a2213] to-[#1f1f1f] border border-[#F5A623]/50 text-left active:scale-[0.99] transition-transform"
        data-testid="home-vip-today-banner"
      >
        <span className="w-9 h-9 shrink-0 rounded-full bg-[#F5A623]/15 flex items-center justify-center"><Crown className="w-5 h-5 text-[#F5A623]" /></span>
        <span className="flex-1 text-sm font-bold text-white">
          Oggi Vincenzo ha scelto <span className="text-[#F5A623]">{matches} {matches === 1 ? 'partita' : 'partite'}</span> per l&apos;Area VIP
        </span>
        <ChevronRight className="w-5 h-5 text-[#F5A623]" />
      </button>
    </div>
  );
};
